import { useState, useEffect } from 'react';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import { MobileTabBar } from './MobileTabBar';
import { InstallHint } from './InstallHint';
import { QuickAddLead } from './QuickAddLead';

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { document.body.classList.add('theme-dark'); return () => document.body.classList.remove('theme-dark'); }, []);
  return (
    <div className="min-h-screen bg-[#0B0F17]">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {open && <div className="fixed inset-0 bg-black/30 z-30 md:hidden" onClick={() => setOpen(false)} data-testid="sidebar-backdrop" />}
      <div className="md:hidden sticky top-0 z-20 flex items-center gap-3 px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))] bg-[#0D131F]/90 backdrop-blur-xl border-b border-[#1F293D]">
        <button onClick={() => setOpen(true)} data-testid="mobile-menu-btn" className="p-1.5 rounded-md hover:bg-gray-100 text-slate-300"><Menu className="h-5 w-5" /></button>
        <span className="font-bold text-white">WholesaleOffers</span>
      </div>
      <main className="md:ml-64 min-h-screen">
        <div className="p-4 pb-40 md:p-8 lg:p-10">
          {children}
        </div>
      </main>
      <InstallHint />
      <QuickAddLead />
      <MobileTabBar onMore={() => setOpen(true)} />
    </div>
  );
}
